import { render, staticRenderFns } from "./TutorialVideos.vue?vue&type=template&id=5cb05942&"
import script from "./TutorialVideos.vue?vue&type=script&lang=ts&"
export * from "./TutorialVideos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports